import { DemoHoldingsOverview } from '../HoldingsOverview';
import { DemoPortfolioOverview } from '../PortfolioOverview';
import { useSortedHoldings } from '../../hooks/useHoldingsSorting';
import type { Portfolio } from '@/hooks/portfolio/usePortfolio';

interface Props {
  portfolio: Portfolio;
}

export const DemoHoldingsPanel = ({ portfolio }: Props) => {
  const sortedHoldings = useSortedHoldings(portfolio.holdings);

  return (
    <div>
      <section>
        <DemoPortfolioOverview portfolio={portfolio} />
      </section>
      <DemoHoldingsOverview
        portfolio={portfolio}
        sortedHoldings={sortedHoldings}
      />
    </div>
  );
};
